import * as Sentry from "@sentry/react";

// Reads runtime config injected by the backend at /app-config.js. Without a DSN
// this is a no-op, mirroring the DSN-gated backend init. Tracing and replay are
// only wired up when their sample rates are > 0, so the default (free-tier safe)
// config sends errors only.
export function initSentry() {
  const config = window.__APP_CONFIG__?.sentry;
  if (!config?.dsn) return;

  const tracesSampleRate = config.tracesSampleRate ?? 0;
  const replaysSessionSampleRate = config.replaysSessionSampleRate ?? 0;
  const replaysOnErrorSampleRate = config.replaysOnErrorSampleRate ?? 1;

  const integrations = [];
  if (tracesSampleRate > 0) integrations.push(Sentry.browserTracingIntegration());
  if (replaysSessionSampleRate > 0 || replaysOnErrorSampleRate > 0) {
    integrations.push(Sentry.replayIntegration({ maskAllText: true, blockAllMedia: true }));
  }

  Sentry.init({
    dsn: config.dsn,
    environment: config.environment,
    release: config.release || undefined,
    tracesSampleRate,
    replaysSessionSampleRate,
    replaysOnErrorSampleRate,
    integrations
  });
}
